import { type CSSProperties, type MouseEvent as ReactMouseEvent } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import BulbIcon from '~/images/icons/BulbIcon';

interface ITipsButtonProps {
  onClick(e: ReactMouseEvent<HTMLButtonElement>): void;
}

export const TipsButton = ({ onClick }: ITipsButtonProps) => {
  const buttonStyle: CSSProperties = {
    all: 'unset',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    height: 30,
    width: 85,
    backgroundColor: colors.secondary[500],
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 3px 10px 1px rgba(0, 0, 0, 0.15)',
    transition: 'transform 0.2s ease-in-out',
  };

  return (
    <button
      type="button"
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <BulbIcon />
      <Typography as="span" bold color={colors.shades[0]} style={{ marginTop: 2 }}>
        Tips
      </Typography>
    </button>
  );
};
